import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { CommonAreaReadModel } from '@client/api';
import { getBuildingId, isDefinedString, TableCell, TableRow, Text, toPriceWithIntervalString, useAreaMetricString } from '@client/toolkit';

import { PortfolioPaths } from '../../portfolio.router';

type CommonAreasListItemProps = {
  commonArea?: CommonAreaReadModel;
  isFetching?: boolean
}

export function CommonAreasListItem({ commonArea, isFetching }: CommonAreasListItemProps) {
  const { t: tType } = useTranslation('type');

  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (!commonArea?.id) return;

    const buildingId = getBuildingId(commonArea.path);

    navigate(generatePath(PortfolioPaths.Space, { buildingId: buildingId, spaceId: commonArea.id, discriminator: commonArea.discriminator }), { replace: true });
  }, [commonArea?.path, commonArea?.id, commonArea?.discriminator, navigate]);

  const area = useAreaMetricString(commonArea?.area);
  // COMMENTED OUT: Driftskostnader - uncomment to restore
  // const operationalCost = toPriceWithIntervalString(commonArea?.operationalCost);

  return (
    <TableRow hover={!!commonArea?.id} onClick={handleClick}>
      <TableCell loading={isFetching} className="font-semibold">
        <Text isEmpty={!isDefinedString(commonArea?.name)}>
          {commonArea?.name}
        </Text>
      </TableCell>

      <TableCell loading={isFetching}>
        <Text isEmpty={!isDefinedString(commonArea?.type)}>
          {tType(`CommonAreaType.${commonArea?.type}`)}
        </Text>
      </TableCell>

      <TableCell loading={isFetching}>
        <Text isEmpty={!isDefinedString(area)}>
          {area}
        </Text>
      </TableCell>

      {/* COMMENTED OUT: Driftskostnader - uncomment to restore
      <TableCell loading={isFetching} align="right">
        <Text isEmpty={!isDefinedString(operationalCost)}>
          {operationalCost}
        </Text>
      </TableCell>
      */}
    </TableRow>
  );
};
